<template>
  <div class="wrap-search">
    <div class="search-bar">
      <!-- 返回按钮 -->
      <div class="return" @click="returnHandle"></div>
      <!-- 输入框组 -->
      <div class="input-group">
        <input ref="input" v-model="key" class="input" type="text" @input="enterSaver" placeholder="请输入关键词进行搜索">
        <div class="btn" @click="searchHandle"></div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  components: {

  },
  props: {

  },
  data () {
    return {
      key: ''
    };
  },
  computed: {

  },
  watch: {

  },
  created () {

  },
  mounted () {
    this.$refs.input.focus();
  },
  methods: {
    // 返回
    returnHandle () {
      this.$emit('return');
    },
    // 搜索
    searchHandle () {
      console.log('搜索关键字：', this.key);
      this.$emit('search', this.key);
      this.returnHandle();
    },
    ...mapActions('nav', [
      // 调用定时器
      'enterSaver'
    ]),
  }
};
</script>

<style scoped lang="scss">
.wrap-search {
  input[type="text"]:focus,
  input[type="password"]:focus {
    border: none;
  }
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999999;
  .search-bar {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -200%);
    display: flex;
    .return {
      width: 128px;
      height: 128px;
      margin: 0 20px 0 0;
      background: url("/images/preloader/btn-return.png") no-repeat;
      background-size: 100%;
    }
    .input-group {
      position: relative;
      width: 1014px;
      height: 128px;
      background: url("/images/preloader/search-group.png") no-repeat;
      background-size: 100%;
      .input {
        position: absolute;
        top: 8px;
        left: 45px;
        width: 755px;
        height: 100px;
        border: none;
        background: transparent;
        color: $color-white;
        padding: 0;
        line-height: 100px;
        font-size: 28px;
        &:focus {
          outline: none;
          border: none;
        }
        &::-webkit-input-placeholder {
          color: #ccc;
        }
      }
      .btn {
        position: absolute;
        width: 200px;
        height: 100px;
        top: 8px;
        right: 14px;
      }
    }
  }
}
@media (orientation: portrait) {
  .search .text{
    font-size: 44px;
  }
}
</style>
